import styled from 'styled-components';

import { 
  PADDING_CONTENT_PAGE, BACKGROUND_CALENDAR, BACKGROUND_CALENDAR_HOVER,
  COLOR_CALENDAR_OUTSIDE, COLOR_CALENDAR_FREE, COLOR_CALENDAR_OCCUPIED, COLOR_CALENDAR_NOTAVAILABLE, COLOR_CALENDAR_BLOCKED, COLOR_CALENDAR_HOLIDAY, FONT_SIZE_CALENDAR, BACKGROUND_CALENDAR_SELECTED,
} from '../../../globals';


export const StyledCalendar = styled.div`
  font-weight: bold;
  font-size: ${FONT_SIZE_CALENDAR}em;
  padding: 0px ${PADDING_CONTENT_PAGE}px 15px ${PADDING_CONTENT_PAGE}px;

  .DayPicker {
    width: 100%;
    font-size: 1.5rem;
  }

  .DayPicker-wrapper {
    width: 100%;
    padding: 0px;
  }

  .DayPicker-Month {
    width: 100%;
    margin: 0;
  }

  .calendar-wrapper-error {
    position: relative;
    height: 150px;
  }

  .DayPicker-Day {
    padding: 2em 1em;
    border-radius: 0;
    border: none;
  }

  .DayPicker-Caption > div{
    color: #333;
    font-weight: bold;
    text-align: center;
    text-transform: capitalize;
    font-size: 1em;
  }

  .DayPicker-Caption {
    padding: 10px;
    height: 100%;
    max-height: 40px;
    font-size: 14px;
  }

  .DayPicker-Weekday {
    color: #333;
    background-color: ${BACKGROUND_CALENDAR};
    font-weight: bold;
    font-size: 12px;
  }

  .DayPicker-Day--free {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_FREE};
  }

  .DayPicker-Day--free:hover {
    background-color: ${BACKGROUND_CALENDAR_HOVER};
  }

  .DayPicker-Day--occupied {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_OCCUPIED};
    cursor: default;
  }

  .DayPicker-Day--notAvailable {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_NOTAVAILABLE};
    cursor: default;
  }

  .DayPicker-Day--blocked {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_BLOCKED};
    cursor: default;
  }

  .DayPicker-Day--holiday {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_HOLIDAY};
    cursor: default;
  }

  .DayPicker-Day--today {
    border: 1px solid black;
    font-weight: inherit;
  }

  .DayPicker-Day--disabled,
  .DayPicker-Day--outside {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_OUTSIDE};
    cursor: default;
    border: none;
  }

  .DayPicker-Day--disabled:hover,
  .DayPicker-Day--outside:hover {
    background-color: ${BACKGROUND_CALENDAR};
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    background-color: ${BACKGROUND_CALENDAR_SELECTED};
  }


  @media (max-width: 767px) {
    font-size: 0.8em;
  }
`;
/*


 

  DayPicker-wrapper:focus {
    border: none;
  }

  .DayPicker-Day:focus {
    outline: none;
  }

  .DayPicker-wrapper:focus {
    outline: none;
  }

  .DayPicker-NavButton:focus {
    outline: none;
  }
  abbr[title], abbr[data-original-title] {
    border: none;
  }


  .DayPicker-Day--free {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_FREE};
  }

  .DayPicker-Day--free:hover {
    background-color: ${BACKGROUND_CALENDAR_HOVER};
  }

  .DayPicker-Day--occupied {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_OCCUPIED};
    cursor: default;
  }

  .DayPicker-Day--notAvailable {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_NOTAVAILABLE};
    cursor: default;
  }

  .DayPicker-Day--blocked {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_BLOCKED};
    cursor: default;
  }

  .DayPicker-Day--holiday {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_HOLIDAY};
    cursor: default;
  }

  .DayPicker-Day--today {
    border: 1px solid black;
    font-weight: inherit;
  }

  .DayPicker-Day--disabled,
  .DayPicker-Day--outside {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_OUTSIDE};
    cursor: default;
    border: none;
  }

  .DayPicker-Day--disabled:hover,
  .DayPicker-Day--outside:hover {
    background-color: ${BACKGROUND_CALENDAR};
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    background-color: ${BACKGROUND_CALENDAR_SELECTED};
  }

*/